import React, { useEffect } from 'react'
import moment from 'moment'

import {
  Box,
  Grid,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from 'src/components/Barcode'
import { Shipment } from 'src/api/models'
import useProfileContext from 'src/context/ProfileContext'

const useStyles = makeStyles(() => ({
  label: {
    padding: '0.5rem',
  },
}))

interface Props {
  shipment: Shipment
  onReadyToPrint?: () => void
}

export const ShipmentPlacard = (props: Props) => {
  const { shipment, onReadyToPrint } = props
  const barcode = { barcode: shipment.guid, type: 'datamatrix', displayName: '' }
  const classes = useStyles()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  const profileContext = useProfileContext()

  return (
    <div className="always-page-break">
      <Box px={5} pt={5}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={4}
          className={classes.label}
        >
          <Grid item xs={4}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={8}>
            <Typography variant="h3">Shipment:</Typography>
            <Typography variant="h3">{shipment.name}</Typography>
            <Typography variant="h5">{shipment.guid}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h3">Order #: {shipment.order?.number}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption">Printed on {moment().format('lll')} by {profileContext.profile?.firstName} {profileContext.profile?.lastName}</Typography>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
